export default "__VITE_ASSET__BPEByWfm__"